
import * as React from "react";
import { useState, useCallback } from "react";

type ToastProps = {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  duration?: number;
  variant?: "default" | "destructive";
};

type ToastState = {
  id: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  duration: number;
  variant?: "default" | "destructive";
};

export function useToast() {
  const [toasts, setToasts] = useState<ToastState[]>([]);

  const toast = useCallback(
    ({ title = "", description, action, duration = 5000, variant = "default" }: ToastProps) => {
      const id = Math.random().toString(36).substring(2, 9);
      
      setToasts((currentToasts) => [
        ...currentToasts,
        { id, title, description, action, duration, variant },
      ]);

      return id;
    },
    []
  );

  const dismiss = useCallback((id: string) => {
    setToasts((currentToasts) =>
      currentToasts.filter((toast) => toast.id !== id)
    );
  }, []);

  return { toast, dismiss, toasts };
}

// Standalone toast function for use outside of components
export const toast = ({ title = "", description, action, duration = 5000, variant = "default" }: ToastProps) => {
  if (typeof window !== "undefined") {
    const event = new CustomEvent("toast", {
      detail: { title, description, action, duration, variant },
    });
    window.dispatchEvent(event);
  }
};

export default useToast;
